"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flat = exports.getExtension = exports.isCSS = exports.isJS = exports.LOCAL_DEV_HOSTS = exports.isBrowserMainThread = exports.isBrowser = exports.isServer = exports.isWorker = void 0;
exports.isWorker = typeof WorkerGlobalScope !== 'undefined';
exports.isServer = !exports.isWorker && typeof window === 'undefined';
exports.isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
exports.isBrowserMainThread = exports.isBrowser && !exports.isWorker;
exports.LOCAL_DEV_HOSTS = [
    'https://bo.wix.com/suricate/tunnel/',
    'https://localhost:',
    'http://localhost:',
    'https://sled.wix.dev/',
];
function isJS(url) {
    return getExtension(url) === 'js';
}
exports.isJS = isJS;
function isCSS(url) {
    return getExtension(url) === 'css';
}
exports.isCSS = isCSS;
function getExtension(url) {
    return url.split('.').pop();
}
exports.getExtension = getExtension;
function flat(arr) {
    var result = [];
    var _flat = function (_arr) {
        _arr.forEach(function (element) {
            if (Array.isArray(element)) {
                _flat(element);
            }
            else {
                result.push(element);
            }
        });
    };
    _flat(arr);
    return result;
}
exports.flat = flat;
//# sourceMappingURL=utils.js.map